"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaqAccordion = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const react_collapsible_1 = __importDefault(require("react-collapsible"));
const fa_1 = require("react-icons/fa");
/**
 * Component: FaqAccordion
 */
const FaqAccordion = (_a) => {
    var { customId, content, panels, showMultipleOpenPanels = true, title, titleClassName, triggerClassName, triggerTrackingProps } = _a, props = __rest(_a, ["customId", "content", "panels", "showMultipleOpenPanels", "title", "titleClassName", "triggerClassName", "triggerTrackingProps"]);
    const [openPanels, setOpenPanels] = (0, react_1.useState)({});
    const onTriggerClick = (0, react_1.useCallback)((idx) => {
        return showMultipleOpenPanels
            ? setOpenPanels((prevState) => (Object.assign(Object.assign({}, prevState), { [idx]: !prevState[idx] })))
            : setOpenPanels((prevState) => ({
                [idx]: !prevState[idx],
            }));
    }, [showMultipleOpenPanels]);
    /**
     * Initialize openPanels
     */
    (0, react_1.useEffect)(() => {
        const openPanelsInit = {};
        let singleOpenPanel = {};
        panels.forEach((panel, index) => {
            const { isExpanded = false } = panel;
            if (Object.keys(singleOpenPanel).length === 0 &&
                isExpanded &&
                !showMultipleOpenPanels) {
                singleOpenPanel = { [index]: isExpanded };
                return;
            }
            openPanelsInit[index] = isExpanded;
            return;
        });
        setOpenPanels(showMultipleOpenPanels ? openPanelsInit : singleOpenPanel);
    }, [panels, showMultipleOpenPanels]);
    if (!title && !content && panels.length < 1) {
        return null;
    }
    return (react_1.default.createElement("section", Object.assign({}, props, { className: (0, classnames_1.default)('w-full my-6', props === null || props === void 0 ? void 0 : props.className) }),
        react_1.default.createElement("div", { id: customId, className: (0, classnames_1.default)('w-full max-w-screen-2xl mx-auto px-4') },
            title && (react_1.default.createElement("h2", { className: (0, classnames_1.default)('font-sofia font-semibold text-xl md:text-2xl mb-6', titleClassName) }, title)),
            content && react_1.default.createElement("div", { className: "custom-rich-text mb-6" }, content),
            panels.length > 0 && (react_1.default.createElement("ul", { className: "accordion", "aria-label": "Frequently Asked Questions" }, panels.map((panel, index) => {
                const { title: question, content: answer, customId } = panel;
                return (react_1.default.createElement("li", { key: index, id: customId },
                    react_1.default.createElement(react_collapsible_1.default, { accordionPosition: index, handleTriggerClick: () => {
                            onTriggerClick(index);
                        }, open: openPanels[index], triggerTagName: "button", triggerElementProps: Object.assign(Object.assign({}, triggerTrackingProps), { className: (0, classnames_1.default)('w-full font-sofia font-semibold text-lg md:text-xl hover:underline aria-expanded:text-black', triggerClassName) }), trigger: react_1.default.createElement("span", { className: "w-full py-2 sm:py-3 flex flex-row items-center relative group" },
                            react_1.default.createElement(fa_1.FaChevronRight, { className: (0, classnames_1.default)('inline-block mr-2 text-base translate-y-px transition-transform', { 'rotate-90': openPanels[index] }), "aria-hidden": true }),
                            question), transitionTime: 200 },
                        react_1.default.createElement("div", { className: "px-8 py-4 rounded-2xl bg-gray-fa 2xl:text-lg" },
                            react_1.default.createElement("div", { className: "w-full" }, answer)))));
            }))))));
};
exports.FaqAccordion = FaqAccordion;
